import {ICON_TYPES} from '../constants';
import {IconPropsType} from '../IconProps.type';
export const GreenSpaceIcon = (props: IconPropsType): JSX.Element => {
  const svgProps = {
    width: props.width || '21',
    height: props.height || '21',
    fill: props.fill || '#43494F',
  };
  return (
    <svg viewBox='0 0 21 21' {...svgProps} xmlns='http://www.w3.org/2000/svg'>
      <path
        d='M20.3857 9.69333C19.8826 9.09746 19.1485 8.75708 18.3706 8.75708H10.5044V6.13121H21V4.38121H10.5044V2.69333L20.9851 2.19283L20.9011 0.44458L2.58212 1.31958L2.66612 3.06783L4.38025 2.98558V4.38121H2.62412V6.13121H4.38025V8.75708H2.63812C1.86025 8.75708 1.12525 9.09921 0.622123 9.69333C0.125123 10.2813 -0.0866274 11.0522 0.0411226 11.8065C0.721873 15.8323 3.42387 19.4093 6.8075 21.0071H14.2012C17.5849 19.4093 20.2869 15.8323 20.9676 11.8065C21.0954 11.0513 20.8836 10.2813 20.3857 9.69333ZM6.12937 2.90246L8.75437 2.77733V4.38121H6.12937V2.90246ZM6.12937 6.13121H8.75437V8.75708H6.12937V6.13121ZM19.2421 11.5142C18.676 14.862 16.5497 17.8781 13.8031 19.2571H7.20475C4.45725 17.8798 2.33275 14.8637 1.76575 11.5142C1.70887 11.1782 1.862 10.9367 1.95825 10.823C2.128 10.6226 2.37562 10.5071 2.63725 10.5071H18.3706C18.6322 10.5071 18.8799 10.6226 19.0496 10.823C19.1459 10.9367 19.299 11.1782 19.2421 11.5142Z'
        fill={svgProps.fill}
      />
    </svg>
  );
};

GreenSpaceIcon.iconType = ICON_TYPES.GREEN_SPACE_ICON;
